const RepackLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_REPACKSHIPMENT_PROFILE",
                "tableName": "",
                "label": "Ship Profile",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            } ,
            {
                "name": "REPACKUPDATEMODE",
                "tableName": "",
                "label": "Update Mode",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
            } ,
            {
                "name": "REPACKDELETEMODE",
                "tableName": "",
                "label": "Delete Mode",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
            }   
        ]
    } 
];

export {
    RepackLayout,
    }
